import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import '@/assets/scss/element-variables.scss';
import '@/assets/scss/main/index.scss';
import { RootStore } from './vuex-store/index';
import VueCookies from 'vue-cookies'
import axios from 'axios'
import VueCompositionAPI from '@vue/composition-api'

// Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

import $ from 'jquery'
Vue.prototype.$ = $;

// 注册富文本编辑器组件为全局组件
Vue.use(ElementUI);
Vue.use(VueCookies);
Vue.use(VueCompositionAPI);

Vue.prototype.$axios = axios;
Vue.prototype.Cookies = VueCookies;
Vue.config.productionTip = false;


new Vue({
  render: h => h(App),
  router: router,
  store: RootStore,
}).$mount('#app')
